import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  @Input() fullCover = false;
  @Input() value = 0;
  color = 'accent';
  mode = 'indeterminate';
  strokeWidth: number = 3;
  diameter: number = 50;

  constructor() {}

  ngOnInit(): void {
    setInterval(() => {
      this.value = parseInt(localStorage.getItem('spinnerProgress'), 10) > 0  ? parseInt(localStorage.getItem('spinnerProgress'), 10) : 0;
    }, 50);
  }
}
